import React from "react";
import SubBanner from "../../components/SubBanner";
import Footer from "../../components/Footer";
import bg from "../../assets/servicess.jpg";
import Tournament from "../../components/Tournament";
import Card from "../../components/CaseStudy";
import Cards from "../../components/Cards/Cards";
import Menu from "../../components/Menu";
const ServicesHome = () => {
  return (
    <>
      {/* Banner Section  */}
      <section>
        <SubBanner heading="Services" subHeading="Home /Services" img={bg} />
      </section>

      {/* Services Section  */}
      <section>
        <Cards />
      </section>
      <section>
        <Menu />
      </section>
      <section>
        <Tournament />
      </section>
      <section>
        <Card />
      </section>
      {/* Footer Section  */}
      <section>
        <Footer />
      </section>
    </>
  );
};

export default ServicesHome;
